import { Injectable } from '@angular/core';
import {Asset} from '../model/asset.model'
import { AngularFirestore } from '@angular/fire/firestore';

import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { GlobalService } from 'src/app/shared/services/global.service';
@Injectable()
export class FirebaseService {
  constructor( public db: AngularFirestore,public globalS: GlobalService) {

  }
 
  getDocument(idt:string, plink:string) {
    return this.db.collection(plink).doc(idt).valueChanges();
  }
  
  getCollectionFB(plink) {
    return this.db
      .collection(plink)
      .valueChanges();
  }
  public getCollectionWhereFB(plink,pnomcampofil,pvalcampofil) {
    console.log('plink,pnomcampofil,pvalcampofil',plink,pnomcampofil,pvalcampofil)
    return this.db
      .collection(plink, ref => ref.where(pnomcampofil, '==', pvalcampofil))
      .valueChanges().pipe(tap(console.log));
  }

  addDocConIdFb() {
   
    const assetForm = {
      questions:
      [
        {
          key: 'code',
          label: 'Código',
          validators:[{key: 'required',  value: ''},
        ],
        errors: [
          {key: 'required',  value: 'Código es requerido'},
          {key:'uniqueKey', value:'El código debe ser unico'}
        ],
        ngClass:'col-md-6',
          order: 1,
          type: 'textbox',
          disabled: true,
          lowerCase: true,
          asyncValidators:[{
            key: 'uniqueKey',
            value:{
              key:'code',
              route:'/empresas/NETSOLINPRUEBA/assets'
            }
          }]
        },
  
        {
          key: 'name',
          label: 'Nombre',
          validators:[{key: 'required',  value: ''},
        ],
        errors: [
          {key: 'required',  value: 'Nombre es requerido'},
        ],
        ngClass:'col-md-6',
          order: 2,
          type: 'textbox',
          lowerCase:true
        },
        
        {
          key: 'class',
          label: 'Clase del activo',
          model: true,
          modelInfo:{
          key:'',
          link: '/netsolinapp/parametros/models'
          },
          optionsLink:'/netsolinapp/parametros/models',
          errors: [
            {key: 'required',  value: 'Clase de activo es requerida'},
          ],
          validators:[{key: 'required',  value: ''},
          ],
          ngClass:'col-6',
          order: 3,
          type: 'dropdown',
          disabled:true,

        },
        {
          key: 'movableAsset',
          label: 'Activo movible',
          value: false,
          ngClass:'col-md-6',
          order: 4,
          type:'checkbox'
        },
        {
          key: 'sede',
          label: 'Sede',
          optionsLink: '/empresas/' + this.globalS.empresaId +'/TABLAS/sede/Registros',
          child:'location',
          childLink: '/empresas/' + this.globalS.empresaId +'/TABLAS/ubicaciones/Registros',
          errors: [
            {key: 'required',  value: 'La sede es requerida'},
          ],
          validators:[{key: 'required',  value: ''},
          ],
          hint:'Es editable en la creacion, y luego por medio de un traslado',
          ngClass:'col-md-6',
          order: 5,
          type: 'dropdown',
          disabled:true,

        },
        {
          key: 'location',
          label: 'Ubicacion',
          errors: [
            {key: 'required',  value: 'La ubicacion es requerida'},
          ],
          validators:[{key: 'required',  value: ''},
          ],
          ngClass:'col-md-6',
          hint:'Es editable en la creacion, y luego por medio de un traslado',
          order: 6,
          type: 'dropdown',
          disabled:true,

        },
          {
            key: 'maker',
            label: 'Fabricante',
            ngClass:'col-md-6',
            order: 7,
            type: 'textbox'
          },
        {
          key: 'modelo',
          label: 'Modelo',
          ngClass:'col-md-6',
          order: 8,
          type: 'textbox'
        },
      
        {
          key: 'serialNumber',
          label: 'Numero de Serial',
        ngClass:'col-md-6',
          order: 9,
          type: 'textbox'
        },
        {
          key: 'barcode',
          label: 'Codigo de barras',
        ngClass:'col-md-6',
          order: 10,
          type: 'textbox'
        },
        {
          key: 'priority',
          label: 'Prioridad',
          options: [
            {key: '1',  value: 'Baja'},
            {key: '2',  value: 'Media'},
            {key: '3',   value: 'Alta'}
          ],
          ngClass:'col-md-6',
          order: 11,
          type: 'dropdown'
        },
        {
          key: 'critical',
          label: 'crítico',
          value: false,
          ngClass:'col-md-6',
          order: 12,
          type:'checkbox',
        },
        {
          key: 'supplier',
          label: 'Proveedor',
          optionsLink: '/empresas/' + this.globalS.empresaId +'/TABLAS/suppliers/Registros',
          ngClass:'col-md-6',
          order: 13,
          type: 'dropdown',

        },
        {
          key: 'dateOfPurchase',
          label: 'Fecha de compra',
          hint:'elegir fecha',
          validators:[{key: 'required',  value: ''},
        ],
        errors: [
          {key: 'required',  value: 'La fecha de compra es requerida'},
        ],
        // minDate:new Date(2000, 2, 10),
        // maxDate:new Date(2002, 2, 10),
          ngClass:'col-md-6',
          order: 14,
          type:'datepicker'
        },
        {
          key: 'documentPrefix',
          label: 'Prefijo',
          hint:'Del documento de compra',
        ngClass:'col-md-6',
          order: 15,
          type: 'textbox'
        },
        {
          key: 'documentNumber',
          label: 'Numero',
          hint:'Del documento de compra',
        ngClass:'col-md-6',
          order: 16,
          type: 'textbox'
        },
        {
          key: 'amount',
          label: 'Cantidad',
          validators: [
            {key: 'required'},
            {key: 'min',  value: '1'}
          ],
          errors: [
            {key: 'min',  value: 'Minimo 1'},
            {key: 'required',  value: 'Cantidad es requerido'},
          ],
          hint:'cantidad de activos con la misma información',
          ngClass:'col-md-4',
          order: 17,
          type: 'numerictextbox'
        },
        {
          key: 'maintenance',
          label: 'Activo de mantenimiento',
          value: false,
          ngClass:'col-md-4',
          order: 18,
          type:'checkbox'
        },
        {
          key: 'financial',
          label: 'Activo financiero',
          value: false,
          ngClass:'col-md-4',
          order: 19,
          type:'checkbox'
        },
        {
          key: 'notes',
          label: 'Notas',
          order: 20,
          ngClass:'col-12',
          type:'textarea'
        },        
        
      ]
    }

    const link='/netsolinapp/parametros/forms'
    const id = 'assetTest2'
    console.log('a grabar form')
    this.db.collection(link).doc(id).set(assetForm);
  }

 
}